import styled from 'styled-components';

export const ListDashItens = styled.ul`
  font-size: ${({ theme }) => {
    return theme.fonts.size.superSmall;
  }};
  font-weight: ${({ theme }) => {
    return theme.fonts.weight.thin;
  }};
  padding-left: 10px;
  li {
    margin-bottom: 5px;
  }
`;
